import React from 'react';
import { PlusIcon, TrashIcon, PencilIcon } from 'lucide-react';
import { useProducts } from '../../context/ProductContext';
export const CategoryManagement: React.FC = () => {
  const {
    categories
  } = useProducts();
  return <div className="container mx-auto px-4 py-8" data-id="element-742">
      <div className="flex justify-between items-center mb-6" data-id="element-743">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-744">
          Category Management
        </h1>
        <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md flex items-center" data-id="element-745">
          <PlusIcon size={18} className="mr-1" data-id="element-746" />
          Add Category
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-747">
        {categories.map(category => <div key={category.id} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden" data-id="element-748">
            <div className="p-6" data-id="element-749">
              <div className="flex justify-between items-start mb-4" data-id="element-750">
                <div data-id="element-751">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-752">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-753">
                    {category.description}
                  </p>
                </div>
                <div className="flex space-x-2" data-id="element-754">
                  <button className="p-1 text-yellow-600 dark:text-yellow-400 hover:text-yellow-800 dark:hover:text-yellow-300" data-id="element-755">
                    <PencilIcon size={18} data-id="element-756" />
                  </button>
                  <button className="p-1 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300" data-id="element-757">
                    <TrashIcon size={18} data-id="element-758" />
                  </button>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700" data-id="element-759">
                <div className="flex justify-between items-center text-sm" data-id="element-760">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-761">
                    Products
                  </span>
                  <span className="font-medium text-gray-900 dark:text-white" data-id="element-762">
                    {/* This would be a count of products in this category */}
                    {Math.floor(Math.random() * 20) + 1}
                  </span>
                </div>
                <div className="flex justify-between items-center text-sm mt-2" data-id="element-763">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-764">
                    Subcategories
                  </span>
                  <span className="font-medium text-gray-900 dark:text-white" data-id="element-765">
                    {category.subcategories?.length || 0}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-900 px-6 py-3" data-id="element-766">
              <button className="w-full text-center text-sm font-medium text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400" data-id="element-767">
                Manage Subcategories
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};